import React from 'react';
import { Row, Col, Progress } from 'antd';

import { Container } from 'src/components';

import styles, { Wrapper, Title } from './preloader.style';
import { IProps } from './preloader.type';

const PreloaderComponent: React.FC<IProps> = (props) => {
  const { text, gradient } = props;

  return (
    <Wrapper>
      <Container type="fluid">
        <Row gutter={16}>
          <Col span={24} className="text-center">
            <Title>{text || 'Carregando...'}</Title>
            <Progress
              style={styles.bar}
              strokeColor={gradient}
              percent={100}
              showInfo={false}
              status="active"
            />
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

export default PreloaderComponent;
